import { useEffect, useState } from "react";
import api from "../../../../services/api";

function ClienteRanking() {
    const [dados, setDados] = useState([]);
    const [filtro, setFiltro] = useState({});

    async function carregar(params = {}) {
        try {
            const res = await api.get("/v1/dashboard/rankingcliente", {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
            });

            const arr = Array.isArray(res.data) ? res.data : [];

            // Apenas 5 primeiros itens
            setDados(arr.slice(0, 10));

        } catch (err) {
            console.error("Erro ranking equipes:", err);
            setDados([]);
        }
    }

    useEffect(() => {
        carregar();
    }, []);

    return (
        <div className="dashboard-card2">

            {/* TÍTULO + BOTÃO ATUALIZAR */}
            <div className="header-row">
                <div className="dashboard-header">
                    <i className="fa fa-user"></i> Ranking de Clientes
                </div>

                <button
                    className="btn btn-sm btn-outline-primary btn-refresh"
                    onClick={() => carregar(filtro)}
                >
                    <i className="fa fa-sync"></i>
                </button>
            </div>

            <div className="dashboard-body">

                {/* LISTAGEM */}
                <div className="list-ranking2 mt-3">

                    {dados.length === 0 ? (
                        <div>Sem dados</div>
                    ) : (
                        <ul className="list-group ranking-list">
                            {dados.map((item, index) => (
                                <li
                                    key={index}
                                    className="list-group-item d-flex align-items-center justify-content-between ranking-item"
                                    style={{
                                        borderRadius: 10,
                                        marginBottom: 8,
                                        padding: "12px 16px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                        border: "1px solid #eee",
                                    }}
                                >
                                    {/* POSIÇÃO */}
                                    <div
                                        className="ranking-posicao"
                                        style={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: "50%",
                                            background: "#2f80ed",
                                            color: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: "bold",
                                            fontSize: 14,
                                        }}
                                    >
                                        {index + 1}
                                    </div>

                                    {/* DESCRIÇÃO */}
                                    <div
                                        className="ranking-descricao flex-grow-1"
                                        style={{
                                            marginLeft: 12,
                                            fontSize: 15,
                                            fontWeight: 500,
                                            color: "#333",
                                        }}
                                    >
                                        {item.nome}
                                    </div>

                                    {/* QUANTIDADE */}
                                    <div
                                        className="ranking-qtde"
                                        style={{
                                            fontSize: 16,
                                            fontWeight: "bold",
                                            color: "#2f80ed",
                                        }}
                                    >
                                        {new Intl.NumberFormat('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        }).format(item.qtde)}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}

                </div>
            </div>
        </div>
    );
}

export default ClienteRanking;
